/** Apply frontend branding even when the unchanged backend renders the shell. */
export function applyGoldllenBranding(doc: Document, subPath = '') {
  const assetRoot = subPath.replace(/\/$/, '');
  const brandTitle = (title: string) =>
    title === 'AFFiNE'
      ? 'Goldllen'
      : title.replace(/ \| AFFiNE$/, ' | Goldllen');
  doc.title = brandTitle(doc.title);
  if (!doc.documentElement.lang) doc.documentElement.lang = 'pt-BR';

  const viewport = doc.querySelector<HTMLMetaElement>('meta[name="viewport"]');
  if (viewport) {
    viewport.content = viewport.content
      .split(',')
      .map(value => value.trim())
      .filter(value => !/^(maximum-scale|user-scalable)\s*=/i.test(value))
      .join(', ');
  }

  for (const meta of doc.querySelectorAll<HTMLMetaElement>(
    'meta[name="twitter:title"], meta[property="og:title"]'
  ))
    meta.content = brandTitle(meta.content);
  const twitterSite = doc.querySelector<HTMLMetaElement>(
    'meta[name="twitter:site"]'
  );
  if (twitterSite?.content === '@AffineOfficial') twitterSite.remove();
  for (const meta of doc.querySelectorAll<HTMLMetaElement>(
    'meta[name="twitter:image"], meta[property="og:image"]'
  )) {
    if (meta.content === 'https://affine.pro/og.jpeg') {
      meta.content = new URL(`${assetRoot}/favicon-512.png`, doc.baseURI).href;
    }
  }

  for (const [rel, file, type] of [
    ['icon', 'favicon.svg', 'image/svg+xml'],
    ['shortcut icon', 'favicon.ico', 'image/x-icon'],
    ['apple-touch-icon', 'apple-touch-icon.png', 'image/png'],
    ['manifest', 'manifest.json', 'application/manifest+json'],
  ]) {
    const link =
      doc.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`) ??
      doc.createElement('link');
    link.rel = rel;
    link.type = type;
    link.href = `${assetRoot}/${file}?v=goldllen-g2`;
    if (rel === 'icon') link.removeAttribute('sizes');
    if (!link.isConnected) doc.head.append(link);
  }
}

if (typeof document !== 'undefined') {
  applyGoldllenBranding(
    document,
    typeof environment === 'undefined' ? '' : environment.subPath
  );
}
